import React from "react";
import { Button } from "antd";
import { FaWrench } from "react-icons/fa";

const CalibrationIntroStep = ({ onNext, onClose }) => {
    return (
        <div className="canvas-calibration-step">
            <button type="button" className="canvas-calibration-step__close" onClick={onClose}>
                ✕
            </button>

            <div className="canvas-calibration-step__center">
                <div className="canvas-calibration-step__icon">
                    <FaWrench />
                </div>

                <h1>Ajusta la escala de tu mapa</h1>

                <p>
                    Te ayudaremos a calibrar tu imagen para que los asientos coincidan con el
                    tamaño real. Durante este proceso podrás acercar la vista, colocar asientos
                    de referencia y ajustar sus dimensiones hasta que se alineen correctamente
                    con tu diseño.
                </p>

                <Button type="link" size="large" onClick={onNext}>
                    Comenzar
                </Button>
            </div>
        </div>
    );
};

export { CalibrationIntroStep };